import { useSelector } from "react-redux";
import "../App.css";
import constants from "../static/constants.json";
import ManagerView from "../components/ManagerView";
import WorkerView from "../components/WorkerView";
import { useNavigate, useParams } from "react-router";
import { useEffect } from "react";

function Home() {
  const user = useSelector((state: any) => state.user);
  const navigate = useNavigate();
  const wildcard = useParams()["*"];

  useEffect(() => {
    console.log("wildcard changed", wildcard);
    if (!user.id && wildcard) {
      localStorage.setItem('job-redirect', wildcard);
      navigate("/sign-in");
    }
    
    
  }, [wildcard]); // eslint-disable-line
  
  const workerContent = (
    <WorkerView />
  )

  const managerContent = (
    <ManagerView />
  );

  const notSignedInContent = <div> you are not signed in</div>;

  return (
    <div className="App">
      {user &&
        user.id &&
        user.personTypeId === constants.personType.worker &&
        workerContent}
      {user &&
        user.id &&
        user.personTypeId === constants.personType.propertyManager &&
        managerContent}
      {(!user || !user.id) && notSignedInContent}
    </div>
  );
}

export default Home;
